export default "__VITE_ASSET__CsWK72El__"